// i18n area 'auth' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da auth.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/auth.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './auth'

export const enGB: DeepPartial<typeof enUS> = {
  user: {
    mfa: {
      startError: 'Could not start the enrolment',
      confirmError: 'Could not confirm the enrolment'
    }
  }
}
